import { FooterView } from '@shared/components/FooterView/FooterView';
import { useCurrencies } from '@shared/contexts/currencies-context';
import {
  Dispatch,
  FC,
  SetStateAction,
  useMemo,
} from 'react';
import { useTranslation } from '../../i18n/useTranslation';

type FooterLink = {
  id: 'terms' | 'privacy' | 'eula' | 'cookie'
  link: string
}

const FOOTER_LINKS: FooterLink[] = [
  {
    id: 'terms',
    link: 'https://fableborne.com/terms',
  },
  {
    id: 'privacy',
    link: 'https://fableborne.com/privacy',
  },
  {
    id: 'eula',
    link: 'https://fableborne.com/eula',
  },
];

interface FooterProps {
  setShowBanner: Dispatch<SetStateAction<boolean>>;
}

export const Footer: FC<FooterProps> = ({ setShowBanner }) => {
  const { footerTranslations, legalTranslations } = useTranslation();

  const getCookie = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowBanner(true);
  };

  const currentYear = useMemo(() => new Date().getFullYear(), []);
  const links = useMemo(
    () => FOOTER_LINKS.map((link) => ({
      ...link,
      label: legalTranslations[link.id],
    })),
    [legalTranslations],
  );

  const { selectedCountryInfo, openRegionChangeModal } = useCurrencies();

  return (
    <FooterView
      links={links}
      footerTranslations={footerTranslations}
      currentYear={currentYear}
      discordUrl="https://discord.com/invite/fableborne"
      twitterUrl="https://x.com/fableborne"
      getCookie={getCookie}
      currencyChangeCountryInfo={selectedCountryInfo}
      onCurrencyChangeClick={openRegionChangeModal}
    />
  );
};
